var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-root",style:({ paddingTop: _vm.topBarHeight + 'px', ..._vm.cssVars() })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("@/assets/packageAssets/common/null_bg.webp"),"alt":""}}),_c('p',{staticClass:"code"},[_vm._v("404")])])
}]

export { render, staticRenderFns }